import { all, call, put, takeEvery } from 'redux-saga/effects';
import * as types from './currencyActionTypes';
import * as actions from './currencyActions';
import * as endpoints from '../../services/endpoints';
import { errorHandler } from '../../helpers/errorHandler';

function* getCurrencySaga(action) {
  try {
    const sessionUserId = localStorage.getItem('sessionUserId');
    const payload = { SessionUserId: sessionUserId, ...(action.payload || {}) };
    const { data } = yield call(endpoints.getCurrencies, payload);
    yield put(actions.getCurrencyDataAction(data));
  } catch (e) {
    yield put(actions.getCurrencyErrorAction(e));
    yield call(errorHandler, e);
  }
}

function* createCurrencySaga(action) {
  try {
    console.log('createCurrencySaga action:', action);
    
    const payload = action.payload.data;
    
    console.log('Create currency API payload:', payload);
    
    const { data } = yield call(endpoints.createCurrency, payload);
    console.log('Create currency API response:', data);
    
    yield put(actions.createCurrencyDataAction(data));
    
    if (data.Result && data.Result.ErrorCode === 0) {
      setTimeout(() => {
        if (action.payload.navigate) {
          action.payload.navigate('/currency');
        }
      }, 2000);
    }
    
  } catch (e) {
    console.error('createCurrencySaga error:', e);
    console.error('Error response:', e.response?.data);
    yield put(actions.createCurrencyErrorAction(e));
    yield call(errorHandler, e);
  }
}

function* updateCurrencySaga(action) {
  try {
    console.log('updateCurrencySaga action:', action);
    
    const payload = action.payload.data;
    
    console.log('Update currency API payload:', payload);
    
    const { data } = yield call(endpoints.updateCurrency, payload);
    console.log('Update currency API response:', data);
    
    yield put(actions.updateCurrencyDataAction(data));
    
    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(actions.getCurrencyRequestAction());
      
      if (action.payload.navigate) {
        setTimeout(() => {
          action.payload.navigate('/currency');
        }, 1000);
      }
    }
    
  } catch (e) {
    console.error('updateCurrencySaga error:', e);
    console.error('Error response:', e.response?.data);
    yield put(actions.updateCurrencyErrorAction(e));
    yield call(errorHandler, e);
  }
}

function* deleteCurrencySaga(action) {
  try {
    console.log('deleteCurrencySaga action:', action);
    
    const payload = action.payload.data;
    
    console.log('Delete currency API payload:', payload);
    
    const { data } = yield call(endpoints.deleteCurrency, payload);
    console.log('Delete currency API response:', data);
    
    yield put(actions.deleteCurrencyDataAction(data));
    
    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(actions.getCurrencyRequestAction());
    }
    
  } catch (e) {
    console.error('deleteCurrencySaga error:', e);
    console.error('Error response:', e.response?.data);
    yield put(actions.deleteCurrencyErrorAction(e));
    yield call(errorHandler, e);
  }
}

export function* currencySaga() {
  yield all([
    takeEvery(types.GET_CURRENCY_REQUEST, getCurrencySaga),
    takeEvery(types.CREATE_CURRENCY_REQUEST, createCurrencySaga),
    takeEvery(types.UPDATE_CURRENCY_REQUEST, updateCurrencySaga),
    takeEvery(types.DELETE_CURRENCY_REQUEST, deleteCurrencySaga),
  ]);
}
